export default __webpack_public_path__ + "d49b4f0722727604f12cd3f71124df49.svg";